import baseInitState from 'src/helpers/redux/baseInitState'
import baseReducer from 'src/helpers/redux/baseReducer'

import { actionType } from './master.action'

const initState = {
  ...baseInitState,
  dpdList: [],
}

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actionType('fetchDPD').success:
      return {
        ...state,
        dpdList: action.payload?.data,
      }

    default:
      return baseReducer(state, action, actionType)
  }
}
